import {
  all,
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';

import {
  listingApi,
} from '../../api';
import {
  errorHandler, successHandler,
} from '../../libs/ga';
import {
  cloneDeep,
  forEach,
} from '../../libs/lodash';

import {
  SUBJECT,
} from './constants';

function* storeSubject(data = {}, merge = true) {
  yield put({
    type: SUBJECT.update,
    data,
    merge,
  });
}

function* fetchSubject({
  data,
}) {
  yield* storeSubject(data);
}

function* updateSubject({
  data, onSuccess,
}) {
  try {
    const {
      _id,
      ...rest
    } = data;
    if (_id) {
      yield call(() => new Promise((resolve, reject) => {
        listingApi.update({
          collection: 'subject',
          payload: {
            _id,
            data: rest,
          },
        }).then(() => resolve(true))
          .catch((error) => reject(error));
      }));
      yield* storeSubject({
        [data._id]: data,
      });
    } else {
      const {
        newData,
      } = yield call(() => new Promise((resolve, reject) => {
        listingApi.create({
          collection: 'subject',
          payload: {
            data,
          },
        }).then((res) => resolve(res.data))
          .catch((err) => reject(err));
      }));
      yield* storeSubject({
        [newData._id]: newData,
      });
    }
    successHandler('Thành công', 'Cập nhật thành công', onSuccess);
  } catch (error) {
    yield* storeSubject();
    errorHandler('Thất bại', error);
  }
}

function* removeSubject({
  _id,
}) {
  const {
    subject,
  } = yield select();
  try {
    yield call(() => new Promise((resolve, reject) => {
      listingApi.remove({
        collection: 'subject',
        payload: {
          _id,
        },
      }).then(() => resolve(true))
        .catch((error) => reject(error));
    }));

    const newData = cloneDeep(subject.data);
    delete newData[_id];
    yield* storeSubject(newData, false);

    successHandler('Thành công', 'Xóa thành công');
  } catch (error) {
    yield* storeSubject();
    errorHandler('Thất bại', error);
  }
}

function* importSubject({
  data = [],
}) {
  yield call(() => new Promise((resolve, reject) => {
    listingApi.importData({
      collection: 'subject',
      payload: {
        data,
      },
    }).then(() => resolve(true))
      .catch((err) => reject(err));
  }));
  const {
    subject,
  } = yield select();
  const newData = cloneDeep(subject.data);
  forEach(
    (obj) => {
      newData[obj._id] = obj;
    },
    data,
  );
  yield* storeSubject(newData);
  successHandler('Thành công', 'Cập nhật thành công');
}

export default function* subjectSaga() {
  yield all([
    yield takeEvery(SUBJECT.handlers.fetch, fetchSubject),
    yield takeEvery(SUBJECT.handlers.import, importSubject),
    yield takeEvery(SUBJECT.handlers.update, updateSubject),
    yield takeEvery(SUBJECT.handlers.remove, removeSubject),
  ]);
}
